import swiper from 'swiper';

var serviseNav = new swiper ('.js-top-access-slider', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  // slidesPerView: 4,
  speed:500,
  autoplay: false,
  spaceBetween: 50,
  slidesPerView: 'auto',
  centeredSlides: true,
  observer: true,
  // observeParents: true,
  preloadImages: false,
  // noSwiping: true,
  autoHeight: true,
  // allowTouchMove: true,
  // watchSlidesVisibility: true,
  // watchSlidesProgress: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 1.5
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    1024: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 'auto',
      spaceBetween: 15,
    }
  }
});
